import React, { createContext, useContext, useCallback, useRef, useState } from 'react';

// ─── Context ──────────────────────────────────────────────────────────────────

const ConfirmContext = createContext(null);

// ─── Provider ─────────────────────────────────────────────────────────────────

export const ConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);
  const resolveRef = useRef(null);

  // Returns a Promise that resolves to true (confirm) or false (cancel)
  const confirm = useCallback(({ title, message, confirmLabel = 'Confirm', danger = false }) => {
    return new Promise((resolve) => {
      resolveRef.current = resolve;
      setDialog({ title, message, confirmLabel, danger });
    });
  }, []);

  const handleConfirm = () => {
    resolveRef.current?.(true);
    setDialog(null);
  };

  const handleCancel = () => {
    resolveRef.current?.(false);
    setDialog(null);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {dialog && (
        <div
          style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            background: 'rgba(0,0,0,0.4)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '1rem',
          }}
          onClick={handleCancel}
        >
          <div
            style={{
              background: 'white', borderRadius: 14, padding: '1.75rem',
              maxWidth: 420, width: '100%',
              boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
              animation: 'fadeInScale 0.15s ease',
            }}
            onClick={e => e.stopPropagation()}
          >
            {dialog.title && (
              <h3 style={{ margin: '0 0 0.5rem', fontSize: '1.05rem', color: '#111827' }}>
                {dialog.title}
              </h3>
            )}
            <p style={{ margin: '0 0 1.5rem', color: '#4b5563', fontSize: '0.9rem', lineHeight: 1.6 }}>
              {dialog.message}
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
              <button
                className="btn btn-outline"
                onClick={handleCancel}
                style={{ minWidth: 80 }}
              >
                Cancel
              </button>
              <button
                className="btn"
                onClick={handleConfirm}
                style={{
                  minWidth: 90,
                  background: dialog.danger ? '#dc2626' : '#0D9488',
                  color: 'white',
                  border: 'none',
                }}
              >
                {dialog.confirmLabel}
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};

// ─── Hook ─────────────────────────────────────────────────────────────────────

export const useConfirm = () => useContext(ConfirmContext);
